import React from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';

import * as S from './styles';
import { ElementDynamicOptionsProps } from 'types/ElementDynamicOptionProps';
import { homeImages } from 'utils/imgList';
import { SortableItem } from 'components/DnDSortalbe/SortableItem';

interface OptionDynamicPageProps {
	option: ElementDynamicOptionsProps;
}

export default function OptionDynamicPage({ option }: OptionDynamicPageProps) {
	// mostrar ou tirar o item de informação da tela
	function showOrHideInformation(
		item: ElementDynamicOptionsProps,
		isShow: boolean
	) {
		const div = document.getElementById(JSON.stringify(item.id));
		if (div) {
			if (isShow) {
				div.style.display = 'block';
			} else {
				div.style.display = 'none';
			}
		}
	}

	return (
		<SortableItem id={option.id}>
			<S.container>
				<S.item $isDragging={false}>
					<S.titleItem>
						<p>{option.name}</p>
						<div
							onMouseOver={() => showOrHideInformation(option, true)}
							onMouseOut={() => showOrHideInformation(option, false)}
						>
							<S.information
								data-testid={`infoMessage-${option.id}`}
								id={JSON.stringify(option.id)}
							>
								<p>{option.description}</p>
							</S.information>
							<AiOutlineInfoCircle />
						</div>
					</S.titleItem>

					<S.imageMod
						$imgSrc={option.image_url || homeImages.bannerIndividual}
					/>
				</S.item>
			</S.container>
		</SortableItem>
	);
}
